console.log('App Init');
import $ from 'jquery';
import CanvasVideoPlayer from './canvas-video-player';

import './jquery.idle.min';

/** MODULES **/
/** Navigation Module **/
let navigation = {
    pageWrapper: $('.page_wrapper'),
    navigationWrapper: $('.navigation_wrapper'),
    triggerBtn: $('.navigation_trigger'),
    closeBtn: $('.navigation_close'),
    container: $('.navigation_items_wrapper'),
    open: function () {
        if (this.triggerBtn.length && this.container.length && this.pageWrapper.length) {
            let _this = this;
            this.triggerBtn.on('click', function (e) {
                e.preventDefault();

                _this.container.addClass('is_open');
                _this.pageWrapper.addClass('navigation_open');
            });
        }
    },
    close: function () {
        if (this.closeBtn.length && this.container.length && this.pageWrapper.length) {
            let _this = this;
            this.closeBtn.on('click', function (e) {
                e.preventDefault();

                _this.container.removeClass('is_open');
                _this.pageWrapper.removeClass('navigation_open');
            });
        }
    },
    scrolled: function () {
        if (this.navigationWrapper.length) {
            if ($(window).scrollTop() > this.navigationWrapper.outerHeight()) {
                this.navigationWrapper.addClass('navigation_scrolled');
            } else {
                this.navigationWrapper.removeClass('navigation_scrolled');
            }
        }
    },
    init: function () {
        this.open();
        this.close();
        this.scrolled();
    }
};
/** END Navigation Module **/

/** Video Canvas Module **/
let canvasVideo = {
    videoSelector: '.video_element',
    canvasSelector: '.canvas_element',
    canvasVideo: function (videoSelector, canvasSelector) {
        if ($(videoSelector).length && $(canvasSelector).length) {
            let isIOS = /iPad|iPhone|iPod/.test(navigator.platform);
            if (isIOS) {

                let canvasVideo = new CanvasVideoPlayer({
                    videoSelector: videoSelector,
                    canvasSelector: canvasSelector,
                    timelineSelector: false,
                    autoplay: true,
                    makeLoop: true,
                    pauseOnClick: false,
                    audio: false
                });

            }else {

                // Use HTML5 video
                document.querySelectorAll(canvasSelector)[0].style.display = 'none';

            }
        }
    },
    init: function () {
        this.canvasVideo(this.videoSelector, this.canvasSelector);
    }
};
/** END Video Canvas Module **/

/** Go To Module **/
let goTo = {
    selector: $('.go_to'),

    init: function () {
        if (this.selector.length) {
            this.selector.on('click', function (e) {
                e.preventDefault();

                let _this = $(this);
                let _contentElement = $(this).closest('.content_element');

                let goToLink = _this.data('go-to');

                let offset = _contentElement.offset().top + _contentElement.outerHeight();
                if(goToLink) {
                    offset = $(goToLink).offset().top;
                }

                $('html, body').animate({
                    scrollTop: offset
                }, 1000);
            });
        }
    }
};
/** END Go To Module **/

/** Video Modal Module **/
let videoModal = {
    selector: $('.youtube_video_trigger'),
    appendVideo: function (videoLink, wrapper) {
        $(wrapper).find('iframe').remove();
        let video = '<video controls autoplay><source src="'+ videoLink +'" type="video/mp4">Your browser does not support HTML video.</video>';
        $(wrapper).append($(video).hide().fadeIn());

        let modalTimeout = setTimeout(function () {
            $(wrapper).find('video').on('timeupdate', function(event){
                console.log(this);
                if( this.currentTime >= this.duration ) {
                    $(wrapper).find('video').fadeOut(function () {
                        $(this).remove();
                    });
                }
            });
            clearTimeout(modalTimeout);
        }, 300);
    },
    makeModal: function (videoLink, videoTitle= '') {
        let _self = this;
        $('.custom_video_modal').remove();

        let title = '';
        if (videoTitle) {
            title = '<h4 class="video_title">'+ videoTitle +'</h4>';
        }

        let video = '<video controls autoplay controlsList="nofullscreen"><source src="'+ videoLink +'" type="video/mp4">Your browser does not support HTML video.</video>';

        let modal = '<div class="custom_video_modal btn_inverse"><a href="#" class="exit_btn"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#ffffff" d="M14.2,12.136,23.544,2.79a1.555,1.555,0,1,0-2.2-2.2L12,9.937,2.655.592a1.555,1.555,0,0,0-2.2,2.2L9.8,12.136.456,21.481a1.555,1.555,0,1,0,2.2,2.2L12,14.334l9.345,9.345a1.555,1.555,0,1,0,2.2-2.2Zm0,0" transform="translate(0 -0.136)"></path></svg><span>Exit video</span></a>'+ title + video +'</div>';
        $('body').append(modal);
        let modalTimeout = setTimeout(function () {
            $('.custom_video_modal').addClass('is_open');

            $('.exit_btn').on('click', function (e) {
                e.preventDefault();

                let modal = $(this).closest('.custom_video_modal');
                modal.removeClass('is_open');

                let closeModalTimeout = setTimeout(function () {
                    modal.remove();

                    clearTimeout(closeModalTimeout);
                }, 600);
            });

            $('.custom_video_modal').find('video').on('timeupdate', function(event){
                if( this.currentTime >= this.duration ) {
                    $('.exit_btn').trigger('click');
                }
            });

            clearTimeout(modalTimeout);
        }, 600);
    },
    init: function () {
        if (this.selector.length) {
            let _this = this;
            this.selector.on('click', function (e) {
                e.preventDefault();
                let videoWrapper = $(this).data('video-wrapper');
                let videoLink = $(this).data('video-link');
                let videoTitle = $(this).data('video-title');
                if (videoLink) {
                    if(videoWrapper) {
                        _this.appendVideo(videoLink, videoWrapper);
                    } else {
                        _this.makeModal(videoLink, videoTitle);
                    }
                } else {
                }
            });
        }
    }
};
/** END Video Modal Module **/

/** Form Inputs Module **/
let formInputs = {
    selector: $('.form-control'),
    init: function () {
        if ($('.wpcf7-form-control-wrap').length) {
            $('.wpcf7-form-control-wrap').each(function () {
                let formControl = $(this);
                let getLabel = formControl.next('label').detach();
                formControl.append(getLabel);

                let id = formControl.find('input, textarea, select').attr('id');
                if(id) {
                    id += '-'+ Date.now();
                    formControl.find('input, textarea, select').attr('id', id);
                    formControl.find('label').attr('for', id);
                }
            });
        }
        if(this.selector.length) {
            this.selector.each(function () {
                let _this = $(this);
                if (_this.val()) {
                    _this.closest('.form-group').addClass('input_filled');
                } else {
                    _this.closest('.form-group').removeClass('input_filled');
                }
            });

            this.selector.on('change input paste', function () {
                let _this = $(this);
                if (_this.val()) {
                    _this.closest('.form-group').addClass('input_filled');
                } else {
                    _this.closest('.form-group').removeClass('input_filled');
                }
            });
        }
    }
};
/** END Form Inputs Module **/

/** Load More Module **/
let loadMore = {
    wrapper: $('.load_more_wrapper'),
    init: function () {
        if (this.wrapper.length) {
            this.wrapper.each(function () {
                let _thisWrapper = $(this);
                let visibleCount = _thisWrapper.data('visible-count');

                _thisWrapper.find('.load_more_trigger').on('click', function (e) {
                    e.preventDefault();
                    let _thisTrigger = $(this);

                    _thisTrigger.closest('.load_more_wrapper').find('.load_more_item').not(':visible').each(function (index) {
                        $(this).fadeIn();
                        if ((index +1) === visibleCount) {
                            return false;
                        }
                    });

                    if (!_thisTrigger.closest('.load_more_wrapper').find('.load_more_item').not(':visible').length) {
                        _thisTrigger.remove();
                    }
                });
            });
        }
    }
};
/** END Load More Module **/

/** Events Ajax Module **/
let eventAjax = {
    selector: '.event_ajax_trigger',
    init: function () {
        if ($(this.selector).length) {
            let _self = this;
            $(document).on('click', _self.selector, function (e) {
                e.preventDefault();
                let _this = $(this);
                let wrapper = _this.data('wrapper');
                let url = _this.data('url');
                let text = _this.text();

                _this.text(text +' ...');

                $.post( url, function( data ) {
                    $(wrapper).html($(data).find(wrapper).html());
                });
            });
        }
    }
};
/** END Events Ajax Module **/

/** Modal Hidden Inputs Module **/
let modalHiddenInputs = {
    trigger: '.modal_hidden_input_trigger',
    selector: '.modal_hidden_input',
    init: function () {
        let _self = this;
        if ($(_self.trigger).length && $(_self.selector).length) {
            $(_self.trigger).on('change', function () {
               let _this = $(this);
               let _thisInputs = _this.closest('.modal').find(_self.selector);
               if (_this.is(':checked')) {
                   _thisInputs.show();
               } else {
                   _thisInputs.hide();
               }
            });
        }
    }
};
/** END Modal Hidden Inputs Module **/


$(document).ready(function () {
    navigation.init();
    canvasVideo.init();
    goTo.init();
    videoModal.init();
    formInputs.init();
    loadMore.init();
    eventAjax.init();
    modalHiddenInputs.init();
    $('.modal_form_submitter').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.modal').find('form input[type="submit"]').trigger('click');
    });
});

$(window).on('load', function () {

});

$(window).resize(function () {

});

$(window).scroll(function() {
    navigation.scrolled();
});

$(document).idle({
    onIdle: function(){
        $('body').addClass('idle_mode');
    },
    onActive: function(){
        $('body').removeClass('idle_mode');
    },
    idle: 2500
});

document.addEventListener( 'wpcf7mailsent', function( event ) {
    $('.input_filled').removeClass('input_filled');

    var setTimeout = window.setTimeout(function() {
        $('.modal').modal('hide');
        window.clearTimeout(setTimeout);
    }, 2000);
}, false );
